import {Component} from '@angular/core';
import {VinSearchService} from "./services/vin-search.service";
import {Vehicle} from "../../models/vehicle";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {WarrantySearchService} from "./services/warranty-search.service";
import {VehicleDto} from "../../auto-generated-server-dtos/warranty-search/vehicle-dto";
import {CreateClaimService} from "../../claim/services/create-claim.service";
import {WarrantyDto} from "../../auto-generated-server-dtos/warranty-search/warranty-dto";
import {Router} from "@angular/router";

@Component({
  selector: 'app-vin-search',
  templateUrl: './vin-search.component.html',
  styleUrls: ['./vin-search.component.css']
})
export class VinSearchComponent {
  public vinSearchTerm = '';
  public warrantyIdSearchTerm = '';
  public vehicles: VehicleDto[] = [];
  public busySearching = false;
  public searchComplete = false;
  loading = false;
  hasSearchButtonBeenClicked: boolean = false;
  public warranties: WarrantyDto[] = [];

  constructor(
    private readonly vinSearchService: VinSearchService,
    private warrantySearchService: WarrantySearchService,
    public activeModal: NgbActiveModal,
    private createClaimService: CreateClaimService,
    private router: Router
  ) {

  }

  public createClaim(warranty: WarrantyDto): void {
    this.createClaimService.CreateClaim(warranty.warrantyId).subscribe(claimId => {
      this.activeModal.close();
      this.router.navigate(['/claim', claimId]).then();
    });

  }

  public search(): void {
    this.busySearching = true;
    this.hasSearchButtonBeenClicked = true;
    if (!!this.vinSearchTerm) {
      this.searchComplete = false;
      this.vinSearchService.VinSearch(this.vinSearchTerm).subscribe({
          next: vehicles => {
            this.vehicles = vehicles;
            this.setWarranties();
          },
          complete: () => {
            this.busySearching = false;
            this.searchComplete = true;
          }
        }
      );
    } else if (!!this.warrantyIdSearchTerm) {
      this.searchComplete = false;
      this.warrantySearchService.WarrantySearch(this.warrantyIdSearchTerm).subscribe({
        next: vehicles => {
          this.vehicles = vehicles;
          this.setWarranties();
        },
        complete: () => {
          this.busySearching = false;
          this.searchComplete = true;
        }
      });
    }
  }

  private setWarranties() {
    let warranties = this.vehicles.map(vehicle => vehicle.applications).flat().map(application => application.warranties).flat();
    this.warranties = warranties.filter(warranty => warranty.status === "Active").concat(warranties.filter(warranty => warranty.status !== "Active"));
  }

  public getVehicleVin(_: number, item: Vehicle): string {
    return item.vin;
  }
}
